export const IMAGE_MODAL_PER_PAGE = 10;
